import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface DrawerBodyProps {
  children?: ReactNode
  gap?: string
  withPadding?: boolean
}

export const DrawerBody = ({ children, gap, withPadding = true }: DrawerBodyProps): ReactElement => (
  <Styled.DrawerBodyWrapper gap={gap} withPadding={withPadding}>
    {children}
  </Styled.DrawerBodyWrapper>
)
